var _rect, _circle, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 1.5,
    stroke: "#9AA3B2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 1.5,
    fill: "white",
    stroke: "#9AA3B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.5V8C3.5 7.72386 3.72386 7.5 4 7.5H8C8.27614 7.5 8.5 7.72386 8.5 8V11.5H3.5Z",
    fill: "white",
    stroke: "#9AA3B2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 2,
    height: 2,
    fill: "#9AA3B2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 4,
    height: 3,
    fill: "#9AA3B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ffa1522c5c29c505c23312d256fab99f.svg";
export { ForwardRef as ReactComponent };